import { render } from "./WNAbnormalCallList.vue?vue&type=template&id=6cec6c0d&scoped=true"
import script from "./WNAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./WNAbnormalCallList.vue?vue&type=script&lang=js"

import "./WNAbnormalCallList.vue?vue&type=style&index=0&id=6cec6c0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cec6c0d"

export default script